import React, {useEffect} from "react";

import HomeCover from "./HomeCover";
import TopPages from "./TopPages";
import { StyledHome } from "./HomeStyles";
import { Footer, Header } from "../../components";
import FundraisingSteps from "./FundraisingSteps";
import { PAGENAME_CONSTANTS } from "../../constants";
import GetInspiredSection from "./GetInspiredSection";
import Tracking from "../../services/tracking.service";

export function Home() {
    
    useEffect(() => {
        Tracking.trackPage({pageName: PAGENAME_CONSTANTS.HOME})
    }, [])

    return <StyledHome>
        <Header />
        <HomeCover />
        <FundraisingSteps />
        <GetInspiredSection />
        <TopPages/>
        <Footer />
    </StyledHome>
}